import React, { useState } from "react";
import axios from "axios";
import Resetpassword_page1 from "../assets/img/Resetpassword_page1.png";
import gmail from "../assets/img/gmail.png";
import { useNavigate } from "react-router-dom";

const ResetpwdPage = () => {
  const [email, setEmail] = useState();
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({});
   const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleChange = (event) => {
    setEmail(event.target.value);
    // console.log(email);
  };
  const emailValidator = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const validation = () => {
    const errorMsgs = {};
    if (!email) {
      errorMsgs.email = "Email is required";
    } else if (!emailValidator(email)) {
      errorMsgs.email = "Invalid email format";
    }
    setErrors(errorMsgs);
    // console.log(errors);
    return Object.keys(errorMsgs).length === 0;
  };
  const extractErrorMessage = (data) => {
    if (typeof data === "string") return data;

    if (data && typeof data === "object") {
      const firstKey = Object.keys(data)[0]; // "email"
      const value = data[firstKey]; // ["Email is not registered"]

      if (Array.isArray(value)) return value[0];
      if (typeof value === "string") return value;
    }

    return "Something went wrong";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validation()) return;
    setLoading(true);
    try {
      const response = await axios.post("/forgot-password", { email });
      const result = response.data;
      setStatus({
        response_code: result.response_code,
        message: extractErrorMessage(result.message),
      });
    } catch (error) {
      const result = error?.response?.data;
      console.error("Reset password error:", result);

      setStatus({
        response_code: result?.response_code || 422,
        message:
          extractErrorMessage(result?.message) ||
          "Something went wrong. Please check your input.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-fluid px-0">
      <div className="row d-flex justify-content-center align-items-center g-0 forgotpwd-container">
        <div className="col-12 col-md-6 forgotpwd-image-col">
          <img src={Resetpassword_page1} alt="Resetpassword_page1" className="img-fluid"></img>
        </div>
        <div className="col-12 col-md-6 forgotpwd-form-col">
          <div className="forgotpwd-content">
            <p className="forgotpwd-title text-center text-muted mb-4">
              Reset Password
            </p>
            <form className="forgotpwd-form" onSubmit={handleSubmit}>

              {/* Status message */}
              {status.response_code && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div
                        className={`modal-header ${
                          status.response_code === 200
                            ? "bg-primary text-white"
                            : "bg-primary text-white"
                        }`}
                      >
                        <h5 className="modal-title">Reset Password</h5>
                      </div>

                      <div className="modal-body">
                        <p className="text-center">{status?.message}</p>
                      </div>

                      <div className="modal-footer">
                        {status.response_code === 200 ? (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => navigate("/Login")}
                          >
                            Ok
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setStatus({})}
                          >
                            Close
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="position-relative">
                <img
                  style={{ position: "absolute", top: "23px", left: "23px" }}
                  src={gmail}
                  alt="gmail"
                ></img>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  className=" form-control px-5 py-3"
                  placeholder="Enter your Email"
                ></input>
                {errors.email && <p className="text-danger small">{errors.email}</p>}
              </div>

              <div className="d-flex justify-content-center">
                <button type="submit" className="btn btn-primary mt-4 w-50">
                  {loading ? (
                    <div className="spinner-border text-light" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Send Password"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetpwdPage;
